module.exports = __webpack_public_path__ + "img/uploadIcon.e3e05a89.png";